/* src/app/pages/agents/agents.component.scss */
.card {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  border: 0;
}
.card .card-header {
  background-color: transparent;
  padding: 1.5rem;
}
.card .card-body {
  padding: 1.5rem;
}
.badge {
  padding: 0.35rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}
.badge.badge-success {
  background-color: var(--success);
  color: white;
}
.badge.badge-danger {
  background-color: var(--danger);
  color: white;
}
.badge.badge-light {
  background-color: #f6f9fc;
  color: #8898aa;
}
.btn-group .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}
.input-group .input-group-text {
  background-color: white;
  border-right: 0;
}
.input-group .form-control {
  border-left: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}
.table th {
  font-size: 0.8125rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}
.table td {
  font-size: 0.875rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  vertical-align: middle;
}
/*# sourceMappingURL=agents.component.css.map */
